import { mapActions, mapState, mapMutations } from "vuex";
import debounce from "lodash/debounce";
import { v4 as uuidv4 } from "uuid";
import bus from "../../plugins/bus";
import draggable from "vuedraggable";
import hub from "../../hub";

export default {
  components: { draggable },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedProject: state => state.project.selectedProject,
      selectedResolution: state => state.project.selectedResolution,
      selectedPage: state => state.project.selectedPage,
      googleFonts: state => state.project.googleFonts,
      projectPages: state => state.project.projectPages,
      saveBlockConfigLoading: state => state.project.saveBlockConfigLoading,
      updatePageLoading: state => state.project.updatePageLoading,
      publishLoading: state => state.project.publishLoading,
      blockDefinitions: state => state.blockDefinitions,
      pageDeleting: state => state.project.pageDeleting,
      blogCategories: state => state.project.blogCategories,
      selectedPageBlocksLoading: state =>
        state.project.selectedPageBlocksLoading,
      selectedPageBlocks: state => state.project.selectedPageBlocks || [],
      openPages: state => state.project.openPages,
      editingBlockId: state => state.project.editingBlockId,
      deletingBlockId: state => state.project.deletingBlockId,
      tempCopiedStyle: state => state.project.tempCopiedStyle,
      onlineUsers: state => state.project.onlineUsers,
      stats: state => state.project.stats,
      isOwnerOfProject: state =>
        state.project.selectedProject.ownerUserId === state.user.id
    }),
    editingBlock() {
      return this.selectedPageBlocks.filter(
        r => r.id == this.editingBlockId
      )[0];
    }
  },
  data() {
    return {
      bus
    };
  },
  directives: {
    hover: {
      inserted: function (el) {
        setTimeout(() => {
          el.classList.add("unhovered");
        }, 100);
      },
      bind: function (el) {
        el.__vHoverOver__ = function () {
          el.classList.remove("unhovered");
        };
        el.__vHoverLeave__ = function () {
          el.classList.add("unhovered");
        };
        el.addEventListener("mouseover", el.__vHoverOver__);
        el.addEventListener("mouseleave", el.__vHoverLeave__);
      },
      unbind: function (el) {
        el.removeEventListener("mouseover", el.__vHoverOver__);
        el.removeEventListener("mouseleave", el.__vHoverLeave__);
        delete el.__vHoverOver__;
        delete el.__vHoverLeave__;
      }
    }
  },
  methods: {
    ...mapActions({
      getProject: "project/getProject",
      getProjectPages: "project/getProjectPages",
      getPageBlocks: "project/getPageBlocks",
      createBlock: "project/createBlock",
      saveBlockConfig: "project/saveBlockConfig",
      updateBlockOrder: "project/updateBlockOrder",
      updatePage: "project/updatePage",
      updateRobotsTxt: "project/updateRobotsTxt",
      updateLanguage: "project/updateLanguage",
      updateInstantClick: "project/updateInstantClick",
      updateShowBranding: "project/updateShowBranding",
      updateDriftId: "project/updateDriftId",
      updateStripeApiKey: "project/updateStripeApiKey",
      updateCustomScript: "project/updateCustomScript",
      saveTheme: "project/saveTheme",
      getGoogleFonts: "project/getGoogleFonts",
      publishProject: "project/publishProject",
      deleteBlockFromPage: "project/deleteBlockFromPage",
      deletePage: "project/deletePage",
      deleteProject: "project/deleteProject",
      exportProject: "project/exportProject",
      getBlogCategories: "project/getBlogCategories",
      getWebsiteStats: "project/getWebsiteStats",
    }),
    ...mapMutations({
      SET_SELECTED_PAGE: "project/SET_SELECTED_PAGE",
      REMOVE_OPEN_PAGE: "project/REMOVE_OPEN_PAGE",
      SET_SELECTED_PROJECT: "project/SET_SELECTED_PROJECT",
      SET_SELECTED_PAGE_BLOCKS: "project/SET_SELECTED_PAGE_BLOCKS",
      SET_SELECTED_PROJECT_PAGES: "project/SET_SELECTED_PROJECT_PAGES",
      TRY_UPDATE_BLOCK_PROP: "project/UPDATE_BLOCK_PROP",
      TRY_DELETE_BLOCK_LIST_ITEM: "project/DELETE_BLOCK_LIST_ITEM",
      TRY_ADD_BLOCK_LIST_ITEM: "project/ADD_BLOCK_LIST_ITEM",
      SET_EDITING_BLOCK_ID: "project/SET_EDITING_BLOCK_ID",
      SET_IS_LARGE_EDITOR: "project/SET_IS_LARGE_EDITOR",
      TRY_UPDATE_PROJECT_PROP: "project/UPDATE_PROJECT_PROP",
      TRY_UPDATE_PAGE_PROP: "project/UPDATE_PAGE_PROP",
      SET_ONLINE_USERS: "project/SET_ONLINE_USERS",
      ALERT_ERROR: "ALERT_ERROR",
      ALERT_SUCCESS: "ALERT_SUCCESS",
      
    }),
    randomId() {
      return uuidv4();
    },
    saveBlockDebounced: debounce(function (block) {
      this.saveBlockConfig(block);
    }, 500),
    onInputSaveTheme: debounce(function () {
      this.saveTheme();
    }, 500),
    onInputUpdatePage: debounce(function (page) {
      this.updatePage(page);
    }, 500),
    getInputSectionsFromDefinitionsByBlockType() {
      for (var group in this.blockDefinitions) {
        var blocks = this.blockDefinitions[group].blocks;
        for (var i = 0; i < blocks.length; i++) {
          if (blocks[i].type === this.block.type) {
            return blocks[i].inputSections;
          }
        }
      }
    },
    geBlockNameByBlockType(type) {
      for (var group in this.blockDefinitions) {
        var blocks = this.blockDefinitions[group].blocks;
        for (var i = 0; i < blocks.length; i++) {
          if (blocks[i].type === type) {
            return blocks[i].name;
          }
        }
      }
    },
    onPageChange(page) {
      this.SET_SELECTED_PAGE(page);
      this.bus.$emit("edit-block", null);
      this.hubJoinPage(this.selectedProject.id, page.id);
      setTimeout(() => {
        this.getPageBlocks();
      }, 0);
    },
    broadcastEventDebounced: debounce(function (type, projectId, payload) {
      hub.broadcastEvent(type, projectId, payload);
    }, 500),
    UPDATE_BLOCK_PROP(data) {
      this.TRY_UPDATE_BLOCK_PROP(data);
      this.saveBlockDebounced(this.editingBlock);
      const payload = {
        data
      };
      this.broadcastEventDebounced(
        "UPDATE_BLOCK_PROP",
        this.selectedProject.id,
        payload
      );
    },
    DELETE_BLOCK_LIST_ITEM(data) {
      this.TRY_DELETE_BLOCK_LIST_ITEM(data);
      this.saveBlockDebounced(this.editingBlock);
      const payload = {
        data
      };
      this.broadcastEventDebounced(
        "DELETE_BLOCK_LIST_ITEM",
        this.selectedProject.id,
        payload
      );
    },
    ADD_BLOCK_LIST_ITEM(data) {
      this.TRY_ADD_BLOCK_LIST_ITEM(data);
      this.saveBlockDebounced(this.editingBlock);
      const payload = {
        data
      };
      this.broadcastEventDebounced(
        "ADD_BLOCK_LIST_ITEM",
        this.selectedProject.id,
        payload
      );
    },
    PASTE_STYLE() {
      this.UPDATE_BLOCK_PROP({
        id: this.editingBlock.id,
        prop: ["config", "style"],
        value: this.tempCopiedStyle
      });
    },
    UPDATE_PROJECT_PROP(data) {
      this.TRY_UPDATE_PROJECT_PROP(data);
      const payload = {
        data
      };
      // do not debounce
      hub.broadcastEvent(
        "UPDATE_PROJECT_PROP",
        this.selectedProject.id,
        payload
      );
    },
    UPDATE_PAGE_PROP(data) {
      this.TRY_UPDATE_PAGE_PROP(data);
      const payload = {
        data
      };
      // do not debounce
      this.broadcastEventDebounced(
        "UPDATE_PAGE_PROP",
        this.selectedProject.id,
        payload
      );
    },
    hubConnectToSocket(cb) {
      hub.connectToSocket(cb);
    },
    hubJoinProjectGroup(id) {
      hub.joinProjectGroup(id);
    },
    hubLeaveProjectGroup(id) {
      hub.leaveProjectGroup(id);
    },
    hubJoinPage(id, pageId) {
      hub.joinPage(id, pageId);
    },
    broadcastBlockCreated(id) {
      this.broadcastEventDebounced(
        "BLOCK_CREATED",
        this.selectedProject.id,
        { id }
      );
    },
    broadcastBlockDeleted() {
      this.broadcastEventDebounced(
        "BLOCK_DELETED",
        this.selectedProject.id,
        {}
      );
    },
    broadcastBlockReordered() {
      this.broadcastEventDebounced(
        "BLOCK_REORDERED",
        this.selectedProject.id,
        {}
      );
    },
    broadcastPageCreated() {
      this.broadcastEventDebounced("PAGE_CREATED", this.selectedProject.id, {});
    },
    broadcastPageDeleted() {
      this.broadcastEventDebounced("PAGE_DELETED", this.selectedProject.id, {});
    },
    subscribeToEvents(id) {
      this.SET_ONLINE_USERS([]);
      hub.getOnlineUsers(parseInt(id));
      hub.on("OnBroadcastEvent", payload => {
        console.log("[hub] OnBroadcastEvent:", payload);
        const { type, data } = payload;
        switch (type) {
          case "UPDATE_BLOCK_PROP":
            this.TRY_UPDATE_BLOCK_PROP(data);
            break;
          case "ADD_BLOCK_LIST_ITEM":
            this.TRY_ADD_BLOCK_LIST_ITEM(data);
            break;
          case "DELETE_BLOCK_LIST_ITEM":
            this.TRY_DELETE_BLOCK_LIST_ITEM(data);
            break;
          case "UPDATE_PROJECT_PROP":
            this.TRY_UPDATE_PROJECT_PROP(data);
            break;
          case "UPDATE_PAGE_PROP":
            this.TRY_UPDATE_PAGE_PROP(data);
            break;
          case "BLOCK_CREATED":
          case "BLOCK_DELETED":
          case "BLOCK_REORDERED":
            this.getPageBlocks();
            break;
          case "PAGE_CREATED":
          case "PAGE_DELETED":
            this.getProjectPages(this.selectedProject.id);
            break;
        }
      });
      hub.on("OnOnlineUsers", payload => {
        console.log("[hub] OnOnlineUsers:", payload);
        this.SET_ONLINE_USERS(payload.filter(user => user.id !== this.user.id));
      });
    }
  }
};
